import React, { PureComponent } from 'react'
import { Switch, Route } from 'react-router-dom'
import FlowManager from 'components/FlowManager'
import { track } from 'utils/trackingUtils'
import { path, isEmpty } from 'ramda'
import config from 'config'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import LoadingPage from 'layouts/LoadingPage'
import OnboardingBotFlow from './OnboardingBotFlow'
import OnboardingCLPFlow from './OnboardingCLPFlow'
import OnboardingPlaybookFlow from './OnboardingPlaybookFlow'
import DemoRequestPlaybookFlow from './OnboardingDemoRequestPlaybookFlow'
import OnboardingPlaybookWebinarStep from 'layouts/OnboardingPlaybookWebinarStep'
import OnboardingInstallStep from 'layouts/OnboardingInstallStep'
import { ONBOARDING_STEP_COUNT, STEP_COUNT_TOTAL } from './constants'

import { api } from 'modules/org/api'
import { fetchEmbedSuccess, fetchEmbedFailed } from 'modules/org/actions'
import { getEmbed } from 'modules/org/selectors'
import { getCustomerSegment } from 'modules/billing/selectors'

import OnboardingRoutes from './routes'
import './style.css'

const STEP_TOTAL = STEP_COUNT_TOTAL - ONBOARDING_STEP_COUNT

const mapStateToProps = (state) => {
  return {
    segment: getCustomerSegment(state),
    embed: getEmbed(state)
  }
}

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    fetchEmbedSuccess,
    fetchEmbedFailed
  }, dispatch),
})

class OnboardingFlow extends PureComponent {

  state = {
    loading: true
  }

  componentDidMount() {
    if (isEmpty(this.props.embed)) {
      this.fetchOrgEmbed()
    } else {
      this.setState({ loading: false })
    }
    track('Playbook Onboarding - Viewed', {pageTitle: "Welcome"})
  }

  fetchOrgEmbed = async () => {
    const { actions } = this.props

    try {
      const embed = await api.fetchEmbed()
      actions.fetchEmbedSuccess(embed)
    } catch (err) {
      actions.fetchEmbedFailed(err)
    } finally {
      this.setState({ loading: false })
    }
  }

  onDone = () => {
    window.location.replace(config.CUSTOMER_WEB_URL)
  }

  onInstallBack = () => {
    const { history } = this.props
    history.push('/onboarding/bot/woohoo')
  }

  render() {
    const { match, history, segment } = this.props
    const url = path(['url'], match)

    if(this.state.loading) {
      return <LoadingPage/>
    }

    return (
      <div className="onboarding-flow--root">
        <FlowManager steps={OnboardingRoutes} stepTotal={STEP_TOTAL} baseUrl={match.url} onDone={this.onDone} history={history} segment={segment} name='Playbook Onboarding'/>
        <Switch>
          <Route path={`${url}/bot-install`} render={()=><OnboardingInstallStep onContinue={this.onInstallBack} path={`${url}/bot-install`} name='Playbook Onboarding' {...this.props}/>}/>
          <Route path={`${url}/bot`} component={OnboardingBotFlow}/>
          <Route path={`${url}/clp`} component={OnboardingCLPFlow}/>
          <Route path={`${url}/playbook`} component={OnboardingPlaybookFlow}/>
          <Route path={`${url}/demo`} component={DemoRequestPlaybookFlow}/>
          <Route path={`${url}/webinar`} component={OnboardingPlaybookWebinarStep}/>
        </Switch>
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(OnboardingFlow)



// WEBPACK FOOTER //
// ./src/flows/OnboardingFlow/index.js